import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageMeta from "../common/PageMeta";
import PageBreadcrumb from "../common/PageBreadCrumb";
import ComponentCard from "../common/ComponentCard";
import Pagination from "../common/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "../ui/table";

import {
  TrashBinIcon,
  PencilIcon
} from "../../icons";
import { Link } from "react-router";
import Badge from "../ui/badge/Badge";
import { getAllSubscriptions, deleteSubscriptionPlanById, emptyRedux } from "../../actions/subscriptionAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { getAllTransactions, resetGetAllSubscriptions, emptyReduxPayments } from "../../actions/paymentAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { configPaths } from '../../config';

export default function AllTransactions() {

  dayjs.extend(relativeTime);

  const perpage = configPaths.recordsPerPage;

  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const [transactionsData, setTransactionsData] = useState([]);

  const [loadData, setLoadData] = useState(true);

  const getAllTransactionsRes = useSelector(state => state.paymentReducer.getAllTransactions);

  const getAllTransactionsFailed = useSelector(state => state.paymentReducer.getAllTransactionsFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showModal, setShowModal] = useState(false);

  const [planToDelete, setPlanToDelete] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  
  useEffect(() => {
      dispatch(checkAuth());
      dispatch(getAllTransactions(perpage, 1));
  }, []);

  useEffect(() => {
    console.log("Logged out error");
    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxPayments());
      logout();
      navigate("/signin");
    }

  }, [checkAuthFailed]);

  useEffect(() => {
      
    if(typeof getAllTransactionsRes != "undefined" && getAllTransactionsRes.statusCode == 200){
      let data = [];

      let transactionsList = getAllTransactionsRes.data.transactions;
      const transactionsData = transactionsList.map((item) => {
          return {
            "id": item.id,
            "paymentId": item.paymentId,
            "transactionId": item.transactionId,
            "amount": item.amount,
            "paidVia": item.paidVia,
            "paymentStatus": item.paymentStatus,
            "createdAt": item.createdAt,
            "paymentData": item.paymentData,
            "user": item.user
          };
      });

      setLoadData(false);
      setTransactionsData([
          ...transactionsData
      ]);

      setTotalRecords(getAllTransactionsRes.data.count);

    }

  }, [getAllTransactionsRes]);

  useEffect(() => {
    //console.log(getAllCustomerFailed);
    //if(getAllTransactionsFailed.statusCode == 401 || getAllTransactionsFailed.statusCode == 500){

          //toast.error(getAllCustomerFailed.message, {autoClose:2000,onClose: () => {

                //logout();
                //navigate("/signin");
          //}});
          setLoadData(false);
    //}
  }, [getAllTransactionsFailed]);
  
  const handleDeleteClick = (id) => {
    setPlanToDelete(id);
    setShowModal(true);  // Show the confirmation modal
  };

  const handleConfirmDelete = () => {
    {/*dispatch(deleteSubscriptionPlanById(planToDelete));
    setSubData(subData.filter(c => c.id !== planToDelete));  // Remove the deleted plan from the state
    setShowModal(false);  // Close the modal
    toast.success("Subscription Plan deleted successfully", {
      position: "bottom-right",
      autoClose: 4000,
    });*/}
  };
  
  const handleCancelDelete = () => {
    setShowModal(false);  // Close the modal without doing anything
  };

  const handlePgNav = (typ) => {
    let pgNum = typ === "next" ? currentPage + 1 : currentPage - 1;

    if(pgNum < 1 || pgNum > Math.ceil(totalRecords / perpage)){
      return;
    }

    setCurrentPage(pgNum);
    setLoadData(true);
    dispatch(getAllTransactions(perpage, pgNum));
  };

  const handleChangePg = (pgNum) => {
    if(!isNaN(pgNum) && pgNum !== currentPage){
      setCurrentPage(pgNum);
      setLoadData(true);
      dispatch(getAllTransactions(perpage, pgNum));
    }
  };

  return (
    <>
      <PageMeta
        title="All Transactions | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Transactions" />
      <div className="space-y-6">
        {/* btn="/subscription/add" */}
        <ComponentCard title="All Transactions list" >
          <div className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/[0.05] dark:bg-white/[0.03]">
            <div className="max-w-full overflow-x-auto">
              <div className="min-w-[1102px]">
                <Table>
                  {/* Table Header */}
                  <TableHeader className="border-b border-gray-100 dark:border-white/[0.05]">
                    <TableRow>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Transaction ID
                      </TableCell>

                      {
                        localStorage.role == 1 ?
                        <TableCell
                          isHeader
                          className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                        >
                          Customer Name
                        </TableCell>
                        : 
                        null
                      }

                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Plan name
                      </TableCell>

                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Amount
                      </TableCell>

                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Paid Via
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Payment Status
                      </TableCell>
                      <TableCell
                        isHeader
                        className="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
                      >
                        Created At
                      </TableCell>
                    </TableRow>
                  </TableHeader>

                  {/* Table Body */}
                  <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
                    {
                      transactionsData.length > 0 
                      ? 
                      transactionsData.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell className="px-5 py-4 sm:px-6 text-start">
                          <div className="flex items-center gap-3">
                            <div>
                              <span className="block font-medium text-gray-800 text-theme-sm dark:text-white/90">
                                {item.transactionId}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        {
                        localStorage.role == 1 ?
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.user ? item.user.firstName + " " + item.user.lastName : "N/A"}
                        </TableCell>
                          : 
                          null
                        }
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item?.paymentData?.subscriptionPlan?.name}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.amount}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.paidVia}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {item.paymentStatus}
                        </TableCell>
                        <TableCell className="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                          {dayjs(item.createdAt).format('DD/MM/YYYY') }
                        </TableCell>
                      </TableRow>
                      
                    ))
                    :
                    <TableRow>
                      <td colSpan={7} className="text-center py-6 text-gray-500">{(loadData === true ? "Loading..." : "No Records Found..!" )}</td>
                    </TableRow>
                  }
                  </TableBody>
                </Table>
              </div>
              {/* Pagination */}
              {
                transactionsData.length > 0 
                ?
                <Pagination
                  totalRecords={totalRecords}
                  perPage={perpage}
                  currentPage={currentPage}
                  handlePgNav={handlePgNav}
                  handleChangePg={handleChangePg}
                />
                :
                null
              }
            </div>
          </div>
        </ComponentCard>
      </div>
      {/* Custom Confirmation Modal using Tailwind CSS */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h3 className="text-lg font-semibold text-gray-700">Confirm Deletion</h3>
            <p className="text-gray-600 mt-2">Are you sure you want to delete this Subscription Plan?</p>
            <div className="mt-4 flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={handleCancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
}